/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkDeleteFacilityServiceAreasResponse } from './BulkDeleteFacilityServiceAreasResponse';
import {
    BulkDeleteFacilityServiceAreasResponseFromJSON,
    BulkDeleteFacilityServiceAreasResponseFromJSONTyped,
    BulkDeleteFacilityServiceAreasResponseToJSON,
} from './BulkDeleteFacilityServiceAreasResponse';

/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreas200Response
 */
export interface BulkDeleteFacilityServiceAreas200Response {
    /**
     * 
     * @type {BulkDeleteFacilityServiceAreasResponse}
     * @memberof BulkDeleteFacilityServiceAreas200Response
     */
    data?: BulkDeleteFacilityServiceAreasResponse;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreas200Response interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreas200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkDeleteFacilityServiceAreas200ResponseFromJSON(json: any): BulkDeleteFacilityServiceAreas200Response {
    return BulkDeleteFacilityServiceAreas200ResponseFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreas200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreas200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : BulkDeleteFacilityServiceAreasResponseFromJSON(json['data']),
    };
}

export function BulkDeleteFacilityServiceAreas200ResponseToJSON(value?: BulkDeleteFacilityServiceAreas200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': BulkDeleteFacilityServiceAreasResponseToJSON(value.data),
    };
}

